/// <amd-module name="VSS/Features/PlatformUI/MessageDialog" />
export { MessageDialog, showMessageDialog } from "./Components/MessageDialog/MessageDialog";
export { IMessageDialogProps } from "./Components/MessageDialog/MessageDialog.Props";
